import { HsShader } from './shader.class';

export class HsShader2D extends HsShader {}
